import { useCollectionListActions } from './useCollectionListActions';
import { useCollectionSelection } from './useCollectionSelection';
import { useCollectionStructureActions } from './useCollectionStructureActions';

/**
 * Public collection action surface for UI components.
 *
 * The former CollectionsContext API is now composed from focused hooks; this
 * wrapper keeps call sites simple without centralizing the implementation again.
 */
export function useCollectionActions() {
  return {
    ...useCollectionListActions(),
    ...useCollectionSelection(),
    ...useCollectionStructureActions(),
  };
}
